import Fade from '@rio-cloud/rio-uikit/Fade';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Sidebar } from '#components/shared/Sidebar.tsx';
import { TourStopDetails } from '#components/tourstopdetails/TourStopDetails.tsx';
import type { Tour } from '#domain/model/Tour.ts';
import { TourDetails } from '#features/tours/sidebar/TourDetails.tsx';

interface TourDetailsSidebarProps {
    tour: Tour;
    setSelectedTourId: (id: string | undefined) => void;
}

export const TourDetailsSidebar = ({ tour, setSelectedTourId }: TourDetailsSidebarProps) => {
    const intl = useIntl();
    const [selectedStopId, setSelectedStopId] = useState<string>();

    const handleBack = () => {
        setSelectedStopId(undefined);
    };

    useEffect(() => {
        if (!selectedStopId) {
            return;
        }

        // When changing the selected tour, reset a stop selection that is no longer valid.
        if (!tour.stops.some(stop => stop.id === selectedStopId)) {
            setSelectedStopId(undefined);
        }
    }, [selectedStopId, tour]);

    const selectedStop = tour.stops.find(stop => stop.id === selectedStopId);
    const hasSelectedStop = !!selectedStopId && !!selectedStop;
    const animationStyle = hasSelectedStop ? 'page' : 'pageBack';

    return (
        <Sidebar
            title={tour?.searchName}
            isOpen={!!tour}
            onClose={() => {
                setSelectedTourId(undefined);
                setSelectedStopId(undefined);
            }}
        >
            <Fade
                initial={false}
                exitBeforeEnter
                animationStyle={animationStyle}
                duration={0.25}
                motionProps={{ transition: { duration: 0.25, type: 'spring' } }}
            >
                {!hasSelectedStop && (
                    <TourDetails key='tourDetails' tour={tour} setSelectedStopId={setSelectedStopId} />
                )}
                {hasSelectedStop && selectedStop && (
                    <TourStopDetails
                        title={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.loadingConfirmation',
                        })}
                        key='tourListDeviation'
                        onBack={handleBack}
                        stop={selectedStop}
                        transportOrders={tour.transportOrders.filter(order =>
                            selectedStop.transportOrderIds.includes(order.id)
                        )}
                        serviceOrders={tour.serviceOrders.filter(order =>
                            selectedStop.serviceOrderIds.includes(order.id)
                        )}
                        type='sidebar'
                    />
                )}
            </Fade>
        </Sidebar>
    );
};
